<template>
  <div
    v-if="fileViewerOpened"
    class="file-viewer fixed pin w-full h-full bg-grey-bg z-10 flex items-center justify-center"
  >
    <div
      class="max-w-2xl w-full h-full md:h-4/5 md:px-6 md:pb-6
        pt-6 bg-white border border-shadow-color flex flex-col"
    >
      <div
        class="mb-2 px-2 md:px-0"
      >
        <Cross
          class="cursor-pointer h-6 w-6"
          @click.native="closeFileViewer"
        />
      </div>
      <iframe
        :src="iframeSrc"
        class="w-full flex-1"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Cross from './icons/Cross.vue';

export default {
  name: 'TheFileViewer',
  components: {
    Cross,
  },
  computed: {
    ...mapState(['currentOverlayFile', 'fileViewerOpened']),
    iframeSrc() {
      if (this.currentOverlayFile) {
        return `https://drive.google.com/file/d/${this.currentOverlayFile.attributes.documentId}/preview`;
      }
      return null;
    },
  },
  methods: mapActions(['closeFileViewer']),
};
</script>


<style lang="css" scoped>
.custom-height {
  height: 80vh;
}
</style>
